import http from './http'

const rsc = {
  async getAcademies () {
    console.log('[rsc]getAcademies')
    return new Promise((resolve, reject) => {
      http.api.get('/resource/academies')
        .then(({ data }) => {
          resolve(data.list)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}

export default rsc
